class ProductTabsSwiper extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('.pr-tabs-header-button'));
    this.templates = Array.from(this.querySelectorAll('template[data-tab-template]'));
    this.swiperEl = this.querySelector('.pr-product-swiper');
    this.wrapperEl = this.swiperEl ? this.swiperEl.querySelector('.swiper-wrapper') : null;
    this.nextBtn = this.querySelector('.swiper-btn-next');
    this.prevBtn = this.querySelector('.swiper-btn-prev');
    this.pagination = this.querySelector('.swiper-pagination');
    this.swiper = null;

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.openTab(button.dataset.tab));
    });

    const initialTab = this.buttons.find((button) => button.classList.contains('active')) || this.buttons[0];
    if (initialTab) this.openTab(initialTab.dataset.tab);
  }

  disconnectedCallback() {
    this.swiper?.destroy(true, true);
  }

  openTab(tab) {
    if (!this.wrapperEl) return;

    const template = this.templates.find((t) => t.dataset.tabTemplate === tab);
    if (!template) return;

    this.buttons.forEach((button) => {
      button.classList.toggle('active', button.dataset.tab === tab);
    });

    // Destroy the previous instance while it still matches the DOM it was built
    // against - destroying after the wrapper's content is already swapped leaves
    // Swiper cleaning up styles/classes on slides that no longer exist, which is
    // what was breaking the rebuilt carousel.
    this.swiper?.destroy(true, true);

    this.wrapperEl.innerHTML = '';
    this.wrapperEl.appendChild(template.content.cloneNode(true));

    // Re-bind Swym wishlist buttons on the freshly swapped-in product cards.
    document.dispatchEvent(new CustomEvent('swym:collections-loaded'));

    this.swiper = new Swiper(this.swiperEl, {
      slidesPerView: Number(this.dataset.mobile) || 1.2,
      spaceBetween: 10,

      // Swiper's Navigation/Pagination modules always read params.navigation.enabled /
      // params.pagination.el, even when unused - passing `undefined` here (rather than
      // omitting the key or using `false`) blows that away and crashes on init.
      pagination: this.pagination ? { el: this.pagination, clickable: true } : false,

      navigation:
        this.nextBtn && this.prevBtn
          ? {
              nextEl: this.nextBtn,
              prevEl: this.prevBtn,
            }
          : false,

      breakpoints: {
        750: {
          slidesPerView: Number(this.dataset.desktop) || 3,
        },
      },
    });
  }
}

customElements.define('product-tabs-swiper', ProductTabsSwiper);
